import React from 'react';
import Grid from "@material-ui/core/Grid"
import Paper from '@material-ui/core/Paper';
import {
    card_title,
    big_paper,
} from "../../Styles/styles";
import './help-center.css'
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import HelpAccounts from "./accounts";
import HelpStrategies from "./strategies";
import HelpAllocationModel from "./allocation-model";
import HelpBuilder from "./builder";

function HelpCenter() {
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>

            <div className="HelpCenterContainer">
                <div className="Title">
                    <Paper style={Object.assign({}, big_paper, {
                        backgroundColor: "transparent",
                        border: "none",
                        padding: "0px"
                    })} elevation={0}>
                        <Grid container direction="row" alignContent="flex-start" justifyContent="space-between">
                            <p style={Object.assign({}, card_title, {marginLeft: "0px", marginTop: "0px"})}>
                                Index Pro Help Center</p>

                        </Grid>
                    </Paper>
                </div>
                <TabContext value={value}>
                    <div className="Tabs">
                        <AppBar position="static" style={{
                            width: "1278px",
                            margin: "auto",
                            color: "black",
                            backgroundColor: "transparent"
                        }} elevation={0}>
                            <TabList value={value} onChange={handleChange} indicatorColor="primary">
                                <Tab label="Accounts" value="1" style={{
                                    fontSize: "14px",
                                    margin: "0px",
                                    textTransform: "none",
                                    minWidth: "150px"
                                }}/>
                                <Tab label="Strategies" value="2" style={{
                                    fontSize: "14px",
                                    margin: "0px",
                                    textTransform: "none",
                                    minWidth: "150px"
                                }}/>
                                <Tab label="Builder" value="3" style={{
                                    fontSize: "14px",
                                    margin: "0px",
                                    textTransform: "none",
                                    minWidth: "150px"
                                }}/>
                                <Tab label="Allocation Model" value="4" style={{
                                    fontSize: "14px",
                                    margin: "0px",
                                    textTransform: "none",
                                    minWidth: "150px"
                                }}/>
                            </TabList>
                        </AppBar>
                    </div>
                    <TabPanel value="1" style={{padding: "0px"}}>
                        <div className="Main">
                            <HelpAccounts/>
                        </div>
                    </TabPanel>
                    <TabPanel value="2" style={{padding: "0px"}}>
                        <div className="Main">
                            <HelpStrategies/>
                        </div>
                    </TabPanel>
                    <TabPanel value="3" style={{padding: "0px"}}>
                        <div className="Main">
                            <HelpBuilder/>
                        </div>
                    </TabPanel>
                    <TabPanel value="4" style={{padding: "0px"}}>
                        <div className="Main">
                            <HelpAllocationModel/>
                        </div>
                    </TabPanel>
                </TabContext>
            </div>
        </div>
    );
}

export default HelpCenter